// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    '[PX][Moved ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '. éëžéëžé]',
  accButtonProgressComplete: (p: { label: string }) =>
    '[PX][' + p['label'] + ' action completed éë]',
  accButtonProgressStatus: (p: { label: string }) =>
    '[PX][' + p['label'] + ' action in progress éë]',
  accColorPalette: () => '[PX][Color Palette é]',
  accColorSwatch: () => '[PX][Color Swatch é]',
  accCommandKey: () => '[PX][Command é]',
  accContextMenuLabel: () => '[PX][actions é]',
  accControlKey: () => '[PX][Close é]',
  accPositionAfter: () => '[PX][after é]',
  accPositionBefore: () => '[PX][before é]',
  accReorderInstructions: (p: { keyPressed: string }) =>
    '[PX][Press and hold ' +
    p['keyPressed'] +
    ' and shift keys, then use the arrow keys to reorder. éëžéëžéëžéëžéëžéëž]',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '[PX][Enter a complete date like this: ' + p['dateExample'] + '. éëžéëžéëž]',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    '[PX][Enter a month and year like this: ' + p['dateExample'] + '. éëžéëžéëž]',
  chart_labelDataLabel: () => '[PX][Label é]',
  chart_labelGroup: () => '[PX][Group é]',
  chart_labelSeries: () => '[PX][Series é]',
  chart_labelValue: () => '[PX][Value é]',
  chart_labelWidthWeight: () => '[PX][Z é]',
  chart_labelX: () => '[PX][X é]',
  chart_labelY: () => '[PX][Y é]',
  checkboxSet_requiredMessageDetail: () => '[PX][Select a value. é]',
  checkbox_helpForCheckbox: () => '[PX][Help for checkbox é]',
  checkbox_requiredMessageDetail: () => '[PX][Select a value. é]',
  checkbox_selected: () => '[PX][Checkbox checked é]',
  checkbox_unselected: () => '[PX][Checkbox not checked é]',
  close: () => '[PX][Close é]',
  collection_apply: () => '[PX][Apply é]',
  collection_cancel: () => '[PX][Cancel é]',
  collection_loaded: () => '[PX][Loaded é]',
  collection_loading: () => '[PX][Loading é]',
  collection_noData: () => '[PX][No data to display. é]',
  collection_pixels: () => '[PX][px é]',
  collection_resizeColumnDialog: () => '[PX][Resize column é]',
  collection_resizeColumnMenu: () => '[PX][Resize Column... é]',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    '[PX][Enter a number between ' + p['MIN'] + ' and ' + p['MAX'] + '. éëžéëž]',
  collection_selectAllRows: () => '[PX][Select all rows é]',
  collection_selectRow: (p: { ROW_NAME: string }) => '[PX][Select row ' + p['ROW_NAME'] + ' é]',
  collection_sortAscendingSubMenu: () => '[PX][Ascending é]',
  collection_sortColumnMenu: () => '[PX][Sort Column é]',
  collection_sortDescendingSubMenu: () => '[PX][Descending é]',
  collection_sortDisabled: () => '[PX][Not sortable é]',
  collection_sortEnabled: () => '[PX][Sortable é]',
  collection_width: () => '[PX][Width é]',
  colorPicker_label: () => '[PX][Color Picker é]',
  confirmation: () => '[PX][Confirmation é]',
  datePicker_currentDate: () => '[PX][Current date é]',
  datePicker_goToToday: () => '[PX][Go to today é]',
  datePicker_label: () => '[PX][Date Picker é]',
  datePicker_month: () => '[PX][Month é]',
  datePicker_months: () => '[PX][Months é]',
  datePicker_next: () => '[PX][Next é]',
  datePicker_nextDecade: () => '[PX][Next decade é]',
  datePicker_nextMonth: () => '[PX][Next month é]',
  datePicker_prev: () => '[PX][Previous é]',
  datePicker_prevDecade: () => '[PX][Previous decade é]',
  datePicker_prevMonth: () => '[PX][Previous month é]',
  datePicker_restricted: () => '[PX][Restricted é]',
  datePicker_selected: () => '[PX][Selected é]',
  datePicker_today: () => '[PX][Today é]',
  datePicker_weekNum: (p: { NUM: string }) => '[PX][Week ' + p['NUM'] + ' é]',
  datePicker_weekNumColLabel: () => '[PX][Week Number é]',
  datePicker_year: () => '[PX][Year é]',
  datePicker_years: () => '[PX][Years é]',
  diagram_promotedLink: () => '[PX][1 link é]',
  diagram_promotedLinkAriaDesc: () => '[PX][Indirect é]',
  diagram_promotedLinks: (p: { num_links: string }) => '[PX][' + p['num_links'] + ' links é]',
  error: () => '[PX][Error é]',
  expandableList_expandCollapseInstructionText: () =>
    '[PX][Use arrow keys to expand and collapse éëžéëž]',
  expandableList_groupCollapse: () => '[PX][Collapsed é]',
  expandableList_groupExpand: () => '[PX][Expanded é]',
  filePicker_addFiles: () => '[PX][Add Files é]',
  filePicker_dropzonePrimaryText: () => '[PX][Drag and Drop é]',
  filePicker_dropzoneSecondaryText: () => '[PX][Select a file or drop one here éëžé]',
  filePicker_dropzoneSecondaryTextMultiple: () => '[PX][Select or drop files here éë]',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "[PX][You can't upload files of type: " + p['fileTypes'] + ' éëžéëžé]',
  filePicker_singleFileUploadError: () => '[PX][Upload one file at a time éë]',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "[PX][You can't upload files of type " + p['fileType'] + ' éëžéëžé]',
  filePicker_unknownFileTypeUploadError: () => '[PX][unknown é]',
  formControl_clear: () => '[PX][Clear é]',
  formControl_day: () => '[PX][Day é]',
  formControl_empty_segment: () => '[PX][Empty é]',
  formControl_helpAvailable: () => '[PX][Help available é]',
  formControl_hide: () => '[PX][Hide é]',
  formControl_hour: () => '[PX][Hour é]',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '[PX][You’ve reached the ' +
    ((
      {
        one: new Intl.NumberFormat('en-XA').format(p['CHARACTER_LIMIT']) + '-character'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('en-XA').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('en-XA').format(p['CHARACTER_LIMIT']) + '-character') +
    ' limit. éëžéëžéëžéëžéëžéëžéëžé]',
  formControl_loading: () => '[PX][Loading é]',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    '[PX][You can enter up to ' + p['MAX_LENGTH'] + ' characters. éëžéëžéë]',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '[PX][Maximum length ' + p['MAX_LENGTH'] + ' exceeded. éëžéëž]',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '[PX][' + p['CHARACTER_COUNT'] + ' characters left. éëžéë]',
  formControl_millisecond: () => '[PX][Millisecond é]',
  formControl_minute: () => '[PX][Minute é]',
  formControl_month: () => '[PX][Month é]',
  formControl_readOnly: () => '[PX][Read only é]',
  formControl_requiredMessageDetail: () => '[PX][Enter a value. é]',
  formControl_second: () => '[PX][Second é]',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    '[PX][Select ' + p['n'] + ' values. é]',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    '[PX][You’ve reached the ' + p['max'] + '-selection limit. éëžéëžé]',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    '[PX][Select ' + p['min'] + ' to ' + p['max'] + ' values. éëž]',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    '[PX][Select at least ' + p['min'] + ' values. éëž]',
  formControl_show: () => '[PX][Show é]',
  formControl_year: () => '[PX][Year é]',
  gantt_labelDate: () => '[PX][Date é]',
  gantt_labelEnd: () => '[PX][End é]',
  gantt_labelLabel: () => '[PX][Label é]',
  gantt_labelRow: () => '[PX][Row é]',
  gantt_labelStart: () => '[PX][Start é]',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    '[PX][' + p['SECTION'] + '. No matching section found. éëžéëž]',
  indexer_keyboardInstructionText: () => '[PX][Press enter to select value. éëž]',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '[PX][Between ' + p['FROM_SECTION'] + ' and ' + p['TO_SECTION'] + '. éëžéëžé]',
  indexer_touchInstructionText: () =>
    '[PX][Double tap and hold to enter gesture mode, then drag up or down to adjust value. éëžéëžéëžéëžéëžéëžé]',
  info: () => '[PX][Info é]',
  inputColor_selectColor: () => '[PX][Select a color é]',
  inputDateMask_date_cleared: () => '[PX][Date cleared é]',
  inputDateMask_dayPlaceholder: () => '[PX][dd é]',
  inputDateMask_empty_segment: () => '[PX][Empty é]',
  inputDateMask_monthPlaceholder: () => '[PX][mm é]',
  inputDateMask_yearPlaceholder: () => '[PX][yyyy é]',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "[PX][Enter a date that's on or before " + p['max'] + '. éëžéëž]',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[PX][Enter a date that's on or after " + p['min'] + '. éëžéëž]',
  inputDatePicker_dateRestrictionMessageDetail: () => '[PX][Enter an available date. éë]',
  inputDatePicker_instruction: () => '[PX][Press Tab to access the calendar. éëžé]',
  inputDatePicker_selectDate: () => '[PX][Select a date é]',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "[PX][Enter a month and year that's on or before " + p['max'] + '. éëžéëžéëž]',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[PX][Enter a month and year that's on or after " + p['min'] + '. éëžéëžéëž]',
  inputNumber_converterParseError: () => '[PX][Enter a number. é]',
  inputNumber_decrease: () => '[PX][Decrease é]',
  inputNumber_increase: () => '[PX][Increase é]',
  inputPassword_hidden: () => '[PX][Password Hidden é]',
  inputPassword_hide: () => '[PX][Hide Password é]',
  inputPassword_show: () => '[PX][Show Password é]',
  inputSensitiveText_hidden: () => '[PX][Sensitive text hidden é]',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    "[PX][Enter a time that's " + p['max'] + ' or earlier. éëžéëž]',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[PX][Enter a time that's " + p['min'] + ' or later. éëžéë]',
  inputTimeMask_time_cleared: () => '[PX][Time cleared é]',
  labelNone: () => '[PX][None é]',
  list_msgFetchCompleted: () => '[PX][Loaded é]',
  list_msgFetchingData: () => '[PX][Loading é]',
  list_suggestion: () => '[PX][Suggestion é]',
  menu_stateLoading: () => '[PX][Loading é]',
  messageToast_allMessagesClosed: () => '[PX][All toast messages are closed. éëžé]',
  message_close: () => '[PX][Close é]',
  message_confirmation: () => '[PX][Success é]',
  message_error: () => '[PX][Error é]',
  message_info: () => '[PX][Info é]',
  message_navigationFromMessagesRegion: () =>
    '[PX][Entering messages region. Press F6 to navigate. éëžéëžéëž]',
  message_navigationToMessagesRegion: () =>
    '[PX][Messages region has new messages. Press F6 to navigate. éëžéëžéëžéë]',
  message_navigationToTouch: () => '[PX][Messages region has new messages. éëžé]',
  message_warning: () => '[PX][Warning é]',
  noData_message: () => '[PX][No items to display é]',
  overflowItemLabel: () => '[PX][More Tabs é]',
  plural_separator: () => ', ',
  popup_close_skipLink: () => '[PX][Double tap to close the open pop-up. éëžéë]',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    '[PX][Entering pop-up. Press F6 to navigate between the pop-up and associated control. éëžéëžéëžéëžéëžéëžé]',
  popup_liveRegion_F6_initial_focus_none: () =>
    '[PX][Pop-up opened. Press F6 to navigate between the pop-up and associated control. éëžéëžéëžéëžéëžéëž]',
  progressIndeterminate: () => '[PX][In Progress é]',
  radioButton_checked: () => '[PX][Radio button checked é]',
  radioButton_selected: () => '[PX][Radio button selected é]',
  radioButton_unchecked: () => '[PX][Radio button not checked éë]',
  radioButton_unselected: () => '[PX][Radio button not selected éë]',
  radio_helpForRadio: () => '[PX][Help for radio button é]',
  radio_requiredMessageDetail: () => '[PX][Select a value. é]',
  selectMultiple_apply: () => '[PX][Apply é]',
  selectMultiple_back: () => '[PX][Back é]',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    '[PX][Use left and right arrow keys to highlight selected values. éëžéëžéëžéëž]',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '[PX][Press Backspace or Delete to remove the selected value. éëžéëžéëžéë]',
  selectMultiple_selectedValues: () => '[PX][Selected values é]',
  selectMultiple_showSelectedValues: () => '[PX][Show selected values only. éë]',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '[PX][' + p['VALUE_COUNT'] + ' values selected. éëžé]',
  select_addToList: () => '[PX][Add to list é]',
  select_addToListAvailable: () => '[PX][Add to list available é]',
  select_closeDropdown: () => '[PX][Press Escape to close. é]',
  select_moreSearchOptions: () => '[PX][More search options é]',
  select_moreSearchOptionsAvailable: () => '[PX][More search options available éëž]',
  select_noMatchesFound: () => '[PX][No matches found. é]',
  select_oneMatchFound: () => '[PX][One match found é]',
  select_requiredMessageDetail: () => '[PX][Select a value. é]',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' matches found éë]',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[PX][' + p['TOTAL_SIZE'] + ' or more matches found éëžéë]',
  selectorAll_deselectAll: () => '[PX][Deselect all é]',
  selectorAll_selectAll: () => '[PX][Select all é]',
  selector_selected: () => '[PX][Checkbox checked é]',
  selector_unselected: () => '[PX][Checkbox not checked é]',
  sheet_close: () => '[PX][Close é]',
  switch_off: () => '[PX][Off é]',
  switch_on: () => '[PX][On é]',
  tabBarNavigationList_removeCueText: () => '[PX][Removable é]',
  tabBar_tabContainsErrors: () => '[PX][Contains errors é]',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => '[PX][Removed ' + p['itemKey'] + ' é]',
  tabbar_labelContextMenu: () => '[PX][has context menu é]',
  tabbar_labelMoveLeft: () => '[PX][Move Left é]',
  tabbar_labelMoveRight: () => '[PX][Move Right é]',
  tabbar_labelRemove: () => '[PX][Remove é]',
  timeComponent_tooltipZoomIn: () => '[PX][Zoom In é]',
  timeComponent_tooltipZoomOut: () => '[PX][Zoom Out é]',
  timeConverter_parseError: () => '[PX][Enter a complete time. é]',
  train_current: () => '[PX][Current é]',
  train_message_type: () => '[PX][Message Type é]',
  train_not_visited: () => '[PX][Not visited é]',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '[PX][Step ' + p['currentStep'] + ' out of ' + p['numberOfSteps'] + ' éëžéëžé]',
  train_visited: () => '[PX][Visited é]',
  userAssistance_learnMore: () => '[PX][Learn more é]',
  userAssistance_required: () => '[PX][Required é]',
  vis_clearSelection: () => '[PX][Clear Selection é]',
  vis_drillable: () => '[PX][Drillable é]',
  vis_invalidData: () => '[PX][Invalid data é]',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    '[PX][' + p['itemCount'] + ' out of ' + p['totalCount'] + ' éëžé]',
  vis_marqueeSelectTooltip: () => '[PX][Marquee select é]',
  vis_marqueeZoomTooltip: () => '[PX][Marquee zoom é]',
  vis_noData: () => '[PX][No data to display é]',
  vis_panTooltip: () => '[PX][Pan é]',
  vis_stateCollapsed: () => '[PX][Collapsed é]',
  vis_stateExpanded: () => '[PX][Expanded é]',
  vis_stateLoaded: () => '[PX][Loaded é]',
  vis_stateLoading: () => '[PX][Loading é]',
  vis_stateSelected: () => '[PX][Selected é]',
  vis_stateUnselected: () => '[PX][Unselected é]',
  warn: () => '[PX][Warning é]'
};
export default bundle;
